module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gLrJ7"))).then(() => module.bundle.root('5erN3'));